export const COLORS_VARIANT_KEYS = {
  iota: 'iota',
  zeta: 'zeta'
} as const

export const STYLES_VARIANT_KEYS = {
  default: 'default',
  ytp: 'ytp'
} as const
